import { create } from 'zustand';
import p2p from '../utils/p2p';

const useP2PStore = create((set, get) => ({
  // State
  isInitialized: false,
  roomId: null,
  isPeerReady: false,
  isConnected: false,
  error: null,

  // Actions
  initialize: (lambdaUrl, turnSecretKey) => {
    const { isInitialized } = get();
    if (isInitialized) return;

    p2p.Config({ 
      lambdaUrl,
      turnSecretKey 
    });

    p2p.OnConnected(() => {
      set({ isConnected: true });
      get().sendMessage(
        new TextEncoder().encode(
          JSON.stringify({
            type: 'ready',
            timestamp: Date.now()
          })
        )
      );
    });

    p2p.OnDisconnected(() => {
      set({ 
        isPeerReady: false,
        isConnected: false 
      });
      get().handleDisconnect?.();
    });

    p2p.OnMessage((data) => {
      const message = JSON.parse(new TextDecoder().decode(data));
      if (message.type === 'ready' && !get().isPeerReady) {
        set({ isPeerReady: true });
      }
      get().handleMessage?.(data);
    });

    p2p.OnError((error) => {
      set({ error });
    });

    set({ isInitialized: true });
  },

  connect: (roomId) => {
    p2p.Open(roomId);
    set({ roomId });
  },

  disconnect: () => {
    p2p.Close();
    set({ 
      roomId: null,
      isPeerReady: false,
      isConnected: false,
      error: null 
    });
  },

  sendMessage: (data) => {
    p2p.Send(data);
  },

  // Optional callback for handling messages
  setMessageHandler: (handler) => {
    set({ handleMessage: handler });
  },

  handleMessage: null,

  // Optional callback for handling disconnection
  setDisconnectHandler: (handler) => {
    set({ handleDisconnect: handler });
  },

  handleDisconnect: null,
}));

export default useP2PStore;